import { render, staticRenderFns } from "./ProductVariantSelect.vue?vue&type=template&id=b2eb6fae&"
import script from "./ProductVariantSelect.js?vue&type=script&lang=js&"
export * from "./ProductVariantSelect.js?vue&type=script&lang=js&"
import style0 from "./ProductVariantSelect.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports